module.exports = __webpack_public_path__ + "static/media/logo-cpissenhorbonfim.eb4b718f.png";